(function () {
  function init(rail) {
    if (rail.dataset.railInit === '1') return;
    rail.dataset.railInit = '1';

    var track = rail.querySelector('[data-rail-track]');
    if (!track) return;
    var nav = rail.querySelector('[data-rail-nav]') || (rail.parentNode ? rail.parentNode.querySelector('[data-rail-nav]') : null);
    var prev = nav && nav.querySelector('[data-rail-prev]');
    var next = nav && nav.querySelector('[data-rail-next]');
    var progressTrack = rail.querySelector('[data-rail-progress-track]');
    var progress = rail.querySelector('[data-rail-progress]');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 4;
      if (nav) nav.style.display = scrollable ? 'inline-flex' : 'none';
      if (progressTrack) progressTrack.hidden = !scrollable;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (progress) {
        var w = Math.min(100, Math.max(12, track.clientWidth / track.scrollWidth * 100));
        var p = max > 0 ? track.scrollLeft / max : 0;
        progress.style.width = w + '%';
        progress.style.left = (p * (100 - w)) + '%';
      }
    }

    var step = function () { return Math.round(track.clientWidth * 0.8); };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    track.addEventListener('wheel', function (e) {
      if (track.scrollWidth <= track.clientWidth) return;
      var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      if (!d) return;
      e.preventDefault();
      track.scrollLeft += d;
    }, { passive: false });

    var dragging = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = false;
      startX = e.clientX; startScroll = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 10) { moved = true; track.classList.add('is-grabbing'); }
      if (moved) track.scrollLeft = startScroll - dx;
    });
    function endDrag() { if (!dragging) return; dragging = false; track.classList.remove('is-grabbing'); }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    update();
  }

  function boot() { document.querySelectorAll('[data-club-rail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-club-rail]');
    if (r) init(r);
  });
})();
